// extracted by mini-css-extract-plugin
export default {"section":"Section_section__lYDcS","sectionTitle":"Section_sectionTitle__RuIC3","label":"Section_label__hYRxv","description":"Section_description__6dhtk"};